import { render, staticRenderFns } from "./Noticeboard.vue?vue&type=template&id=b73fa866&"
import script from "./Noticeboard.vue?vue&type=script&lang=js&"
export * from "./Noticeboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports